import { ComboChartBarDatum, ComboChartData } from './types'

export const NULL_SERIES_SUFFIX = 'COMBO-CHART-NULL_SERIES_SUFFIX'

export const buildComboChartData = (chartData: ComboChartData[]) => {
  const data: Record<string, ComboChartBarDatum> = {}

  chartData.forEach(({ id, data: chartDatum }) => {
    chartDatum.forEach(({ x, y }) => {
      data[x] ||= { x }
      data[x][id] = y
    })
  })

  return Object.values(data)
}

export const extractLineNullSeries = (chartData?: ComboChartData): ComboChartData[] => {
  if (!chartData) return []

  let currentChartData: ComboChartData | undefined = undefined
  const { id, data, color } = chartData
  const nullChartData: ComboChartData[] = []

  data.forEach(({ x, y }, index) => {
    const hasNullValue = y === null

    if (hasNullValue) {
      if (currentChartData) {
        currentChartData.data.push({ x, y })
      } else {
        currentChartData = { id: `${id}-${index}-${NULL_SERIES_SUFFIX}`, color, data: [] }
        const previousData = data[index - 1]
        if (previousData) currentChartData.data.push({ x: previousData.x, y: previousData.y })
        currentChartData.data.push({ x, y })
      }
    } else if (currentChartData) {
      currentChartData.data.push({ x, y })
      nullChartData.push(currentChartData)
      currentChartData = undefined
    }
  })

  if (currentChartData) {
    nullChartData.push(currentChartData)
    currentChartData = undefined
  }

  return nullChartData
}
